<template>
    <div id="userList">
        <div class="searchContent">
            <div class="p_select" style="float: right;">
                <a class="add_btn" @click="addItem"><i class="el-icon-plus"></i>新增</a>
            </div>
        </div>
        <div class="list_content">
            <el-table :data="planListData" :height=winHeight>
                <el-table-column prop="targetPlanId" align="left" label="ID"></el-table-column>
                <el-table-column prop="targetPlanName" align="left" label="计划名称"></el-table-column>
                <el-table-column prop="startTime" align="left" label="开始日期"></el-table-column>
                <el-table-column prop="endTime" align="left" label="结束日期"></el-table-column>
                <el-table-column label="状态" align="left">
                    <template slot-scope="scope">
                        <el-switch
                                v-model='scope.row.isUsing'
                                active-color="#ff4949"
                                inactive-color="#13ce66"
                                active-text="禁用"
                                inactive-text="启用"
                                active-value='0'
                                inactive-value='1'
                                @change="changePlanStatus(scope.row.isUsing,scope.row)"
                        ></el-switch>
                    </template>
                </el-table-column>

                <el-table-column label="操作" align="left">
                    <template slot-scope="scope">
                        <el-button
                                @click="updateDiction(scope.row)"
                                class="update_btn"
                                size="small"
                        >修改</el-button>
                        <el-button
                                @click="configureDetail(scope.row)"
                                class="update_btn"
                                size="small"
                        >目标</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <el-drawer
                title="新增计划"
                :visible.sync="showAddData"
                direction="rtl"
                :wrapperClosable=true
                size="60%"
                @close="noAddData">
            <el-form ref="form" :model="planForm" label-width="100px">
                <el-form-item label="计划名称:" required>
                    <el-input v-model="planForm.targetPlanName" placeholder="请输入计划名称"></el-input>
                </el-form-item>
                <el-form-item label="开始时间:" required>
                    <el-date-picker
                            v-model="planForm.startTime"
                            style="width: 100%"
                            type="date"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="结束时间:" required>
                    <el-date-picker
                            v-model="planForm.endTime"
                            style="width: 100%"
                            type="date"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="重点部位:" required>
                    <el-checkbox-group v-model="checkPosition">
                        <el-checkbox v-for="checkPosition in positionList"
                                     :label="checkPosition.positionId"
                                     :value="checkPosition.positionId"
                                     :key="checkPosition.positionId" >
                            {{checkPosition.positionName}}
                        </el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
            </el-form>
            <div class="position_box_btn">
                <a class="sure_btn" @click="submitAdd">确认新增</a>
                <a class="cancel_btn" @click="noAddData">取消</a>
            </div>
        </el-drawer>
        <el-drawer
                title="修改模板"
                :visible.sync="showEditData"
                direction="rtl"
                :wrapperClosable=true
                @close="noUpdateData">
            <el-form ref="form" :model="planForm" label-width="100px" style="height: 300px">
                <el-form-item label="计划ID:">
                    <el-input v-model="planForm.targetPlanId" disabled></el-input>
                </el-form-item>
                <el-form-item label="计划名称:" required>
                    <el-input v-model="planForm.targetPlanName" placeholder="请输入计划名称"></el-input>
                </el-form-item>
                <el-form-item label="开始时间:">
                    <el-date-picker
                            disabled
                            v-model="planForm.startTime"
                            style="width: 100%"
                            type="date"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="结束时间:">
                    <el-date-picker
                            disabled
                            v-model="planForm.endTime"
                            style="width: 100%"
                            type="date"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div class="position_box_btn">
                <a class="sure_btn" @click="submitEdit">确认修改</a>
                <a class="cancel_btn" @click="noUpdateData">取消</a>
            </div>
        </el-drawer>


    </div>
</template>


<script>
  import net from "../../assets/js/public";
  export default {
    data() {
      return {
        orgId:'',
        planListData:[],

        positionList:[],
        checkPosition:[],

        showAddData: false,
        showEditData: false,
        planForm:{
          targetPlanId:'',
          targetPlanName:'',
          startTime:'',
          endTime:'',
        },


        winHeight:'200'

      };
    },
    created() {
      var signInfo = JSON.parse(sessionStorage.getItem("signInfo"));
      if(signInfo.orgId > 0){
        this.orgId = signInfo.orgId
      }
      this.getListData()

      this.getPositionList()

    },
    methods: {
      // 获取所有部位
      getPositionList(){
        net.request("admin/manage/parts/getPositionList","post").then(res => {
          if (res.code === 0) {
            this.positionList = res.data
          } else {
            net.message(this, "获取数据失败", "warning");
          }
        })
      },
      getListData() {
        const params = {
          orgId: this.orgId
        }
        net.request("manage/targetPlan/list","post", params).then(res => {
          if (res.code === 0) {
            let planListData = res.data
            planListData.forEach(item => {
              item.isUsing = item.isUsing + ''
            })
            this.planListData = planListData
            this.winHeight = net.setWindowHeight()
          } else {
            net.message(this, "获取数据失败", "warning");
          }
        })
      },
      addItem(){
        this.showAddData = true
        this.planForm.targetPlanName = ''
        this.planForm.startTime = ''
        this.planForm.endTime = ''
        this.checkPosition = []
      },
      submitAdd(){
        const params = {
          targetPlanName: this.planForm.targetPlanName,
          startTime: this.planForm.startTime,
          endTime: this.planForm.endTime,
          isUsing:1,
          orgId: this.orgId,
          positionIds:this.checkPosition
        }
        net.request("manage/targetPlan/add", "post", null, params).then(res => {
          if (res.code === 0) {
            net.message(this, "操作成功", "success");
            this.showAddData = false
          } else {
            net.message(this, res.msg, "warning");
          }
        });
      },
      noAddData(){
        this.showAddData = false
        this.getListData()
      },
      configureDetail(row){
        sessionStorage.setItem("planDetail", JSON.stringify(row));
        this.$router.push({ path: '/planDetail' });
      },
      changePlanStatus(isUsing, row){
        let params = {
          targetPlanId:row.targetPlanId,
          isUsing: isUsing
        }
        this.editPlan(params)
      },
      updateDiction(row){
        this.showEditData = true
        this.planForm = row
      },
      submitEdit(){
        const params  = {
          targetPlanId:this.planForm.targetPlanId,
          targetPlanName:this.planForm.targetPlanName,
        }
        this.editPlan(params)

      },
      editPlan(params){
        net.request("manage/targetPlan/update", "post", null, params).then(res => {
          if (res.code === 0) {
            net.message(this, "操作成功", "success");
          } else {
            net.message(this, res.msg, "warning");
          }
          this.showEditData = false
          this.noUpdateData()
        });
      },

      noUpdateData(){
        this.showEditData = false
        this.getListData()
      },
    }
  };
</script>

<style lang='less' scoped>
    /deep/ .el-table th.el-table__cell {
        background: #F3F7FB !important;
        color: #364556;
    }
    .el-checkbox-group .el-checkbox {
        width: 150px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        text-align: left;
    }
    #userList {
        padding-left: 24px;
        padding-top: 24px;
        .el-tabs {
            border-radius: 8px;
            background: #fff;
            padding: 24px;
        }
        .searchContent {
            background: #fff;
            padding-left: 12px;
            padding-top: 12px;
            .p_select {
                display: flex;
                padding: 0 12px 12px 0;
                font-size: 12px;
                float: left;
                .search_label{
                    font-family: 'PingFang SC';
                    font-style: normal;
                    margin-right: 12px;
                    font-weight: 500;
                    font-size: 14px;
                    line-height: 40px;
                    color: #787E86;
                    white-space:nowrap
                }

                .el-input , .el-select{
                    width: 160px;
                }
            }
            .search_btn {
                width: 76px;
                height: 36px;
                line-height: 36px;
                background: #2B54FC;
                box-shadow: 0px 4px 12px rgba(71, 134, 192, 0.24);
                border-radius: 4px;
                color: #FFFFFF;
                font-size: 14px;
            }
            .add_btn {
                width: 76px;
                height: 36px;
                line-height: 36px;
                background: rgba(148, 170, 204, 0.08);
                border: 1px solid #2B54FC;
                border-radius: 4px;
                font-size: 14px;
                color: #2B54FC;
            }

        }
        .list_content {
            background: #fff;
            padding-left: 12px;
            padding-right: 12px;
        }
        .update_btn {
            width: 54px;
            height: 28px;
            background: rgba(148, 170, 204, 0.08);
            border: 1px solid #E3E7ED;
            border-radius: 14px;
            font-size: 12px;
            color: #364556;
            text-align: center;
        }
    }


</style>


